export const BackgroundMode = Object.freeze({
    NONE: "none",
    COLOR: "color",
    IMAGE: "image"
  });